import { ReactElement } from 'react';

import styles from './styles.module.scss';

import { ErrorComponent } from ':components';

export const ErrorPage = (): ReactElement => (
  <ErrorComponent
    className={styles.ErrorPage}
    title='Сервис временно недоступен'
    subtitle='При загрузке сервиса произошла ошибка, попробуйте обновить страницу'
    buttonTitle='Обновить страницу'
    onButtonClick={() => {
      window.location.reload();
    }}
  />
);
